module.exports = __webpack_public_path__ + "static/img/illustratepic_01.feb05c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/illustratepic_01.png
// module id = +k7w
// module chunks = 1